import React, { useState,useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./templates/header";
import LeftBar from "./templates/left_bar";
import Loader from '../common/Loader'
import ApiService from "../../services/api.service";
import { addFarmerInfo } from "../../store/actions/updateFarmerInfo";

import { useDispatch, useSelector } from "react-redux";

import {addWalletInfo} from '../../store/actions/saveWalletInfo'

import {addWalletMoreInfo, selectedWalletInfo} from '../../store/actions/selectedWallet'

import { productReducer } from "../../store/reducers/ProductReducer";
import ErrorMag from "../common/ErrorMag";

import { toTitleCase } from './summary';
import { currencyFormatter } from '../common/Utils';
const Verify = ({ navigation }) => {
    const navigate = useNavigate();
    const [showSelect, setShowSelect] = useState(0);
    const location = useLocation();
    const [farmerId, setFarmerId] = useState((location.state && location.state.farmerid !== undefined) ? location.state.farmerid : "");

    const [loader, showLoader] = useState(false);
    const [error, setError] = useState('');
    const [noProductserror, setnoProductserror] = useState('')
    const [verifyClass, setVerifyClass] = useState('grayout')
    const [cardInfo, setCardInfo] = useState({})
    const [disabledNav, disabledNavigate] = useState(true)
    const wallets = useSelector((state) => state.wallets)
    const [wallet, setWallet] = useState( (location.state && location.state.walletId !== undefined) ? wallets.filter((item) => item.walletReferenceCode === location.state.walletId)[0] : {})
    const [bal_err, setBalError] = useState(false);
    const dispatch = useDispatch();
    const products = useSelector((state) => { return state.products; });
    const farmer = useSelector((state) => { return state.farmer; });
    const wallet_info = useSelector((state) => { try{return JSON.parse(state.wallet_info);} catch(e){return {}}  });
    const userCredentials = useSelector((state) => { return state.userCredentials; });
    const [errorMagData, seterrorMagData] = useState({})
    const[selectedwallet, setWalletName]=useState('')
    const [selectProductsButton, setSelectProductsButton] = useState('grayout');
    const handleVerify = (e) => {
        e.preventDefault();
        showLoader(true)
        ApiService.get(`/farmer/validate?customerId=${farmerId}&program=${userCredentials.Program}`).subscribe((res) => {
            
            if (res.data !== undefined && res.data !== null) {
                showLoader(false)
                dispatch(addFarmerInfo(res.data ? res.data : { idNumber: farmerId }))
                getWallets();
                //call wallets api
                setShowSelect(1)
            } else if (res.response !== undefined && res.response !== null) {
                showLoader(false)
                if (res.response.data.status === 400) {
                    setError(res.response.data.error ? res.response.data.error : "Farmer ID not found")
                    return
                }
                setError("Farmer ID not found");
                return
            } else {
                showLoader(false)
                setError("An error occurred");
            }
        })

    }

    useEffect(() => () => { window.history.replaceState({}, document.title);},[])

    const getWallets = () => {
        ApiService.get("/farmer/program_wallets?program=INUA_MKULIMA").subscribe((res) => {
            if (res !== undefined && res !== null) {
                dispatch(addWalletInfo(res.data))
            }
        })
    }

    const getCardInfo = (customer_id, walletRef, walletName) => {
        ApiService.get("/farmer/card?customerId=" + customer_id + "&walletReferenceCode=" + walletRef).subscribe((res) => {
            try {
                if (res !== undefined && res !== null) {
                    if (res.data !== undefined && res.data !== null) {
                        dispatch(selectedWalletInfo(res.data))
                        setCardInfo(res.data)
                        checkProducts(userCredentials.MerchantID, res.data.PAN, walletRef)
                    }
                }

            } catch (err) {
                throw JSON.stringify(err)
            }

        })
    }

    const handleOnchange = (val) => {
        val.length >= 6 ? setVerifyClass("rm") : setVerifyClass('grayout')
    }
    const handleSelect = (e) => {
        e.preventDefault();
        if (Number(wallet_info.AvailableAmount)<=0) {
            const errorDtl = {
                err_name: "invalid_bal",
                err_title: "Insufficient Wallet Balance",
                err_desc: `The Selected ${toTitleCase(selectedwallet)} wallet has insufficient balance to complete the transaction. Please adjust the selected products.`,
                err_w_bal: currencyFormatter(wallet_info.AvailableAmount),
                order_amt: "Your Balance should be greater than 0"
            }
            seterrorMagData(errorDtl)
            setBalError(true);
            return;
        }
        navigate("/service-dashboard", { state: { merchantCode: "POSMR002337", walletAccountNumber: "6910400169687447", walletReferenceCode: wallet.walletReferenceCode, famerid: farmerId } });


    }

    const checkProducts = (merchantCode, walletAccountNumber, walletReferenceCode) => {
        showLoader(true)
        let payload = { merchantCode: merchantCode, walletAccountNumber: walletAccountNumber, walletReferenceCode: walletReferenceCode }
        ApiService.post("/farmer/products", payload).subscribe((res) => {
            if (res !== undefined && res !== null) {
                showLoader(false)
                if (res.data !== undefined && res.data !== null) {
                    if (Object.keys(res.data).length > 0) {
                        disabledNavigate(false)
                        setSelectProductsButton('')
                        dispatch(productReducer(res.data))
                        setnoProductserror('')
                        return
                    } else {
                        setnoProductserror("No products for this wallet")
                        return
                    }
                } else if (res.response !== undefined && res.response !== null) {
                    if (res.response.data && res.response.data.status && res.response.data.status === 400) {
                        setnoProductserror(res.response.data.error.message)
                        return
                    }
                }
                setSelectProductsButton('grayout')
                setnoProductserror("Unable to check products. Try again later")
                return
            }
            showLoader(false)
            setSelectProductsButton('grayout')
            setnoProductserror("Unable to check farmer's products, Try again")
            return
        })
    }

    const productsChecker = (customer_id, walletRef, walletName) => {
        showLoader(true)
        disabledNavigate(true)
        dispatch(selectedWalletInfo({}))
        ApiService.get("/farmer/loadproduct?customerId="+customer_id+"&walletReferenceCode="+walletRef).subscribe((res) => {
            if (res !== undefined && res !== null) {
                showLoader(false)
                if (res.data !== undefined && res.data !== null) {
                    let products = res.data.products ? res.data.products : [{}]
                    let walletinfo = res.data.account ? res.data.account : {}
                    if(Object.keys(walletinfo).length == 0) {
                        setnoProductserror("Wallet Account Error")
                        showLoader(false)
                        return
                    }
                    if (products.length == 0) {
                        setnoProductserror("No products for this wallet")
                        showLoader(false)
                        return
                    }
                    disabledNavigate(false)
                    dispatch(selectedWalletInfo(walletinfo))
                    setCardInfo(walletinfo)
                    dispatch(productReducer(products))
                    setSelectProductsButton('')
                    setnoProductserror('')
                    showLoader(false)
                    return

                } else if (res.response !== undefined && res.response !== null) {
                    if (res.response.data && res.response.data.status && res.response.data.status === 400) {
                        setnoProductserror(res.response.data.error.message ? res.response.data.error.message : res.response.data.error ? res.response.data.error : "No Products Assigned"  )
                        return
                    }

                }
                setSelectProductsButton('grayout')
                setnoProductserror("Unable to check products. Try again later")
                return
            }
            showLoader(false)
            setSelectProductsButton('grayout')
            setnoProductserror("Unable to check farmer's products, Try again")
            return
        })
    }

    return (
        <>

            <div className="home_landing">
                {/* render header */}
                <Header />
                <div className="home_app">
                    {bal_err && <ErrorMag setBalError={setBalError} errorMagData={errorMagData} />}
                    <LeftBar />
                    <div className="home_data_template_preset">
                        <div className="verify">
                            <Loader loader={loader} />
                            
                            <div className="verify_wrapper">
                                <h3 className="verify_wrapper_heading">
                                    Verify Farmer
                                </h3>
                                
                                <form className="verify_wrapper_form">
                                    <div className="verify_wrapper_form_container">
                                        <label htmlFor="farmer_id" className="verify_wrapper_form_label">
                                            Farmers ID number
                                        </label>
                                        <div className="verify_wrapper_form_container_sub">
                                            <input value={farmerId} onChange={(e) => { setFarmerId(e.target.value); handleOnchange(e.target.value); setError(''); dispatch(addWalletInfo([])); dispatch(addFarmerInfo({}));  dispatch(selectedWalletInfo({}))}} placeholder="Enter farmers ID number" type="text" id="farmer_id" className="verify_wrapper_form_input" />
                                            <button className={`verify_wrapper_form_btn_verify ${verifyClass}`} onClick={handleVerify}>
                                                Verify
                                            </button>
                                        </div>
                                        {
                                            ( farmerId && !Array.isArray(farmer) && typeof farmer === 'object' &&
                                            (farmer !== null && farmer !== undefined) && Object.keys(farmer).length > 0)
                                            && <span style={{ color: "#00513b", marginTop: '.5rem',fontFamily: 'Noto-Bold' }}>Account Name: <strong>{`${farmer.firstName} ${farmer.lastName}`}</strong></span>
                                        }
                                    </div>


                                    {error !== "" ? <>
                                        <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id">
                                            {error}
                                        </label> </> : <></>
                                    }

                                    {((wallets.length > 0 && farmerId))? <>
                                        <div className="verify_wrapper_form_container">
                                            <label htmlFor="select_wallet" className="verify_wrapper_form_label">
                                                Select wallet to transact from
                                            </label>
                                            <select name="wallets" className="verify_wrapper_form_input"
                                                    id="select_wallet" onChange={(e) => {
                                                setError('');
                                                if (e.target.value !== "") {
                                                    showLoader(true);
                                                    dispatch(addWalletMoreInfo(wallets.filter((item) => item.walletReferenceCode === e.target.value)[0]));
                                                    productsChecker(farmerId, e.target.value, e.target.options[e.target.selectedIndex].text);
                                                    setWalletName(e.target.options[e.target.selectedIndex].text)
                                                } else {
                                                    setWallet({});
                                                }
                                            }}>
                                                <option value="" defaultValue>Select wallet</option>
                                                {wallets.map((wallet, i) => <option key={i} value={wallet.walletReferenceCode}>{wallet.walletName?.replace("_", " ")}</option>)}
                                            </select>
                                            {
                                            (farmerId && !Array.isArray(wallet_info) && typeof wallet_info === 'object' &&
                                            (wallet_info !== null && wallet_info !== undefined) && Object.entries(wallet_info).length > 0)
                                                &&
                                                <span style={{ color:" #009438", marginTop: "0.5rem", fontFamily: "Noto-Bold", fontSize: "medium" }}>Available Balance: <strong>{wallet_info.CardCurrency+' '+currencyFormatter(wallet_info.AvailableAmount)}</strong></span>
                                            }
                                            {noProductserror !== "" ? <>
                                                <label htmlFor="farmer_id" className="verify_wrapper_form_label error_label invalid_id">
                                                    {noProductserror}
                                                </label> </> : <></>
                                            }


                                        </div>
                                        <button disabled={disabledNav} className={`verify_wrapper_form_btn_verify select ${disabledNav ? 'grayout' : ""}`} onClick={handleSelect}>Proceed</button>
                                    </>
                                        : <></>
                                    }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default Verify;

